import styled from 'styled-components'
import { ViewBase } from '@bestyled/primitives'

import {
  commonProps,
  CommonProps,
  flexContainerProps,
  FlexContainerProps,
  flexItemProps,
  FlexItemProps
} from '@bestyled/system'

export interface WrapProps
  extends FlexContainerProps,
    FlexItemProps,
    CommonProps {}

/** The Wrap component handles the flex box model, normalized for cross-platform with flutter like props. */
export const Wrap = styled(ViewBase<WrapProps>('Wrap'))`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
    align-content: stretch;
    ${flexContainerProps} ${flexItemProps} ${commonProps}
`

Wrap.defaultProps = {
  alignMainAxis: 'flex-start',
  alignCrossAxis: 'stretch'
}
